"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetProductDetails = void 0;
const Base_1 = require("./Base");
exports.GetProductDetails = {
    url: Base_1.URL_BASE + "/GetProductDetails",
    method: "GET",
    secure: true
};
//# sourceMappingURL=GetProductDetails.js.map